import React from 'react'

export default function DashboardContentSkeleton() {
  return (
    <div className="flex flex-col items-center w-full max-w-[360px] p-4">
      {/* Avatar */}
      <div className="relative">
        <div className="w-32 h-32 rounded-full bg-gray-300 animate-pulse" aria-hidden />
        <div className="absolute bottom-1 right-2 w-[29px] h-[29px] rounded-full bg-gray-300 animate-pulse" aria-hidden />
      </div>

      <div className="mt-4 h-5 w-20 bg-gray-300 rounded animate-pulse" />

      <div className="mt-8 w-full flex flex-col gap-3">
        <div className="h-12 w-full bg-gray-300 rounded-xl animate-pulse" />
        <div className="h-12 w-full bg-gray-300 rounded-xl animate-pulse" />
        <div className="h-12 w-full bg-gray-300 rounded-xl animate-pulse" />
        <div className="h-12 w-full bg-gray-300 rounded-xl animate-pulse" />
        <div className="h-12 w-full bg-gray-300 rounded-xl animate-pulse" />
        <div className="h-12 w-full bg-gray-300 rounded-xl animate-pulse" />
        <div className="h-12 w-full bg-gray-300 rounded-xl animate-pulse" />

      </div>
    </div>
  )
}
